export { default } from '@shikijs/langs/liquid'
